import { DisplacementResponse, PortCallPurpose } from '@navstation-portal/reporting/data-model/vessel-report';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { createFormStoreEvents } from '../create-form-store-events';

export const operationalEvents = createFormStoreEvents('operationalStore');

export const operationalCalculationEvents = eventGroup({
  source: 'operationalStore',
  events: {
    getDisplacement: type<{ draught: number }>(),
    getDisplacementSuccess: type<DisplacementResponse>(),
    getDisplacementFailed: type<Error>(),
  },
});

export const operationalReferenceDataEvents = eventGroup({
  source: 'operationalStore',
  events: {
    getPortCallPurposes: type<void>(),
    getPortCallPurposesSuccess: type<PortCallPurpose[]>(),
    getPortCallPurposesFailed: type<Error>(),
  },
});
